import React from 'react';
import { withProps } from 'recompose';

import Money from '../../../common/money';
import ToolTip from '../../../common/PortalledTooltip';
import { t } from '../../../../modules/infra/i18n';

export const getColumns = () => [
  {
    Header: t('reports:sales_by_barber.columns.barber_name'),
    accessor: 'barberName',
    id: 'barberName',
  },
  {
    Header: t('reports:sales_by_barber.columns.productivity'),
    accessor: 'productivity',
    id: 'productivity',
    Cell: props => `${props.value || 0}%`,
  },
  {
    Header: t('reports:sales_by_barber.columns.service_sales'),
    accessor: 'serviceGrossTotal',
    id: 'serviceGrossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.product_sales'),
    accessor: 'productGrossTotal',
    id: 'productGrossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.gross_sales'),
    accessor: 'grossTotal',
    id: 'grossTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.product_service_sales'),
    accessor: 'productServiceRatio',
    id: 'productServiceRatio',
    Cell: props => props.original.serviceGrossTotal ? Number(props.value).toFixed(2) : t('reports:sales_by_barber.values.na'),
  },
  {
    Header: t('reports:sales_by_barber.columns.refunds'),
    accessor: 'grossRefunds',
    id: 'grossRefunds',
    Cell: props => <Money cents={props.value} />,
  },
  {
    accessor: 'grossDiscounts',
    id: 'grossDiscounts',
    Header: () => (
      <div>
        <span>{t('reports:sales_by_barber.columns.discounts')}</span>
        <div className="u-inline-block u-position-relative">
          <ToolTip className="u-type--no-transform" align="bottom">
            {t('reports:sales_by_barber.columns.discounts_tooltip')}
          </ToolTip>
        </div>
      </div>
    ),
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.net_sales'),
    accessor: 'netTotal',
    id: 'netTotal',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.tips'),
    accessor: 'tips',
    id: 'tips',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: t('reports:sales_by_barber.columns.services_sold'),
    accessor: 'serviceQuantitySold',
    id: 'serviceQuantitySold',
  },
  {
    Header: t('reports:sales_by_barber.columns.products_sold'),
    accessor: 'productQuantitySold',
    id: 'productQuantitySold',
  },
];

export const withDefaultColumns = withProps(() => ({ columns: getColumns() }));
